import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Toast from './Toast';

export default {
  title: 'Components/Toast',
  component: Toast,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

const ToastTemplate = ({ message, type }) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Toast
      message={message}
      type={type}
      onClose={() => setIsOpen(!isOpen)}
    />
  );
};

ToastTemplate.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'neutral']).isRequired,
};

const Template = ToastTemplate.bind({});

export const SuccessToast = Template.bind({});
SuccessToast.args = {
  message: 'Success',
  type: 'success',
};

export const ErrorToast = Template.bind({});
ErrorToast.args = {
  message: 'Error',
  type: 'error',
};

export const WarningToast = Template.bind({});
WarningToast.args = {
  message: 'Warning',
  type: 'warning',
};

export const InfoToast = Template.bind({});
InfoToast.args = {
  message: 'Info',
  type: 'info',
};

export const NeutralToast = Template.bind({});
NeutralToast.args = {
  message: 'Neutral',
  type: 'neutral',
};

